import React, { Suspense, lazy } from 'react';
import { FlashSaleBar } from './components/FlashSaleBar';
import { HeroSection } from './components/HeroSection';
import { useMetaPixel } from './hooks/useMetaPixel';
const PainPoints = lazy(() => import('./components/PainPoints').then(m => ({
  default: m.PainPoints
})));
const Benefits = lazy(() => import('./components/Benefits').then(m => ({
  default: m.Benefits
})));
const UniqueMechanism = lazy(() => import('./components/UniqueMechanism').then(m => ({
  default: m.UniqueMechanism
})));
const ProductHero = lazy(() => import('./components/ProductHero').then(m => ({
  default: m.ProductHero
})));
const ContentBreakdown = lazy(() => import('./components/ContentBreakdown').then(m => ({
  default: m.ContentBreakdown
})));
const BonusItems = lazy(() => import('./components/BonusItems').then(m => ({
  default: m.BonusItems
})));
const TestimonialCarousel = lazy(() => import('./components/TestimonialCarousel').then(m => ({
  default: m.TestimonialCarousel
})));
const FAQAccordion = lazy(() => import('./components/FAQAccordion').then(m => ({
  default: m.FAQAccordion
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const StickyCTA = lazy(() => import('./components/StickyCTA').then(m => ({
  default: m.StickyCTA
})));
const SaleNotifications = lazy(() => import('./components/SaleNotifications').then(m => ({
  default: m.SaleNotifications
})));
const ExitIntentPopup = lazy(() => import('./components/ExitIntentPopup').then(m => ({
  default: m.ExitIntentPopup
})));
function SectionLoader() {
  return <div className="w-full py-[40px] flex justify-center items-center" data-id="element-0">
      <div className="flex flex-col items-center gap-3" data-id="element-1">
        <div className="w-8 h-8 border-[3px] border-[#A78BFA] border-t-transparent rounded-full animate-spin" data-id="element-2" />
      </div>
    </div>;
}
export function App() {
  useMetaPixel();
  return <div className="min-h-screen bg-[#F8F6FF] text-[#1F2937] overflow-x-hidden font-[Poppins]" data-id="element-3">
      <FlashSaleBar data-id="element-4" />
      <HeroSection data-id="element-5" />
      <Suspense fallback={<SectionLoader data-id="element-7" />} data-id="element-6">
        <PainPoints data-id="element-8" />
      </Suspense>
      <Suspense fallback={<SectionLoader data-id="element-10" />} data-id="element-9">
        <Benefits data-id="element-11" />
      </Suspense>
      <Suspense fallback={<SectionLoader data-id="element-13" />} data-id="element-12">
        <UniqueMechanism data-id="element-14" />
      </Suspense>
      <Suspense fallback={<SectionLoader data-id="element-16" />} data-id="element-15">
        <ProductHero data-id="element-17" />
      </Suspense>
      <Suspense fallback={<SectionLoader data-id="element-19" />} data-id="element-18">
        <ContentBreakdown data-id="element-20" />
      </Suspense>
      <Suspense fallback={<SectionLoader data-id="element-22" />} data-id="element-21">
        <BonusItems data-id="element-23" />
      </Suspense>
      <Suspense fallback={<SectionLoader data-id="element-25" />} data-id="element-24">
        <TestimonialCarousel data-id="element-26" />
      </Suspense>
      <Suspense fallback={<SectionLoader data-id="element-28" />} data-id="element-27">
        <FAQAccordion data-id="element-29" />
      </Suspense>
      <Suspense fallback={<SectionLoader data-id="element-31" />} data-id="element-30">
        <PricingSection data-id="element-32" />
      </Suspense>
      <Suspense fallback={<SectionLoader data-id="element-34" />} data-id="element-33">
        <Footer data-id="element-35" />
      </Suspense>
      <Suspense fallback={null} data-id="element-36">
        <StickyCTA data-id="element-37" />
      </Suspense>
      <Suspense fallback={null} data-id="element-38">
        <SaleNotifications data-id="element-39" />
      </Suspense>
      <Suspense fallback={null} data-id="element-40">
        <ExitIntentPopup data-id="element-41" />
      </Suspense>
    </div>;
}